var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    typography = _ref.typography,
    colors = _ref.colors;
  return {
    stimulusPadding: spacing.large,
    buttonWrapperPadding: spacing.small,
    headerPadding: spacing.small,
    optionPadding: spacing.small,
    stimulusContentPadding: spacing.small,
    stimulusContentPaddingBottom: spacing.small,
    stimulusButtonsColor: colors.contrasts.grey100100,
    stimulusButtonsZIndex: '3333'
  };
};
export default generateComponentTheme;